let password;

export default function (...args)
{
	return {

		getValue(default_value)
		{
			const stored = password ?? default_value;
			if (stored !== undefined && stored !== null && stored !== '')
				return stored;
			// Senha só sincroniza em change/blur; se usuário submete sem sair do campo, ler do DOM
			const node = document.querySelector(this.selector);
			return node?.value ?? default_value;
		},

		setValue(value)
		{
			password = this.format(value, this.store_mask);
		}

	};
}

